import React from 'react';
import GlobalErrorsBox from '../../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import Label from '../../FormElements/Label';
import TextInput from '../../FormElements/TextInput';
import DateOfBirthInput from '../../FormElements/DateOfBirthInput';
import FormSection from '../../FormElements/FormSection';
import FormSubmit from '../../FormElements/FormSubmit';
import LoaderOverlay from '../../LoaderOverlay/LoaderOverlay';

export default class EditUserPersonalDataForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			firstName: '',
			lastName: '',
			dateOfBirthMonth: '',
			dateOfBirthDay: '',
			dateOfBirthYear: '',
			emailAddress: '',
			phoneNumber: '',
			addressLine1: '',
			addressLine2: '',
			city: '',
			stateAbr: '',
			zipCode: '',
			globalErrors: [],
			fieldErrors: {}
		};

		this.onChange = this.onChange.bind(this);
		this.onSetFieldError = this.onSetFieldError.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount() {
		// console.log('About to load data...');
		this.loadData();
	}

	componentDidUpdate(prevProps) {
		// console.log('prevProps', prevProps);
		if (
			prevProps.iam_get_user_personal_endpoint !==
			this.props.iam_get_user_personal_endpoint
		) {
			// console.log('About to reload data...');
			this.loadData();
		}
	}

	render() {
		// console.log(
		// 	'Edit User Profile - Personal Form - Props',
		// 	this.props,
		// 	'Edit User Profile - Personal Form - State',
		// 	this.state
		// );

		return (
			<div style={{ width: '100%' }}>
				<div className="FormElements">
					<form onSubmit={this.onSubmit}>
						<FormSection>
							<GlobalErrorsBox globalErrors={this.state.globalErrors} />
							<div className="my-3">
								<Label>{I18n.t('admin.user_profile.first_name')}</Label>
								<TextInput
									style={this.styleTextInputOnError('firstName')}
									placeholder=""
									name="firstName"
									value={this.state.firstName}
									onChange={this.onChange}
									fieldErrors={this.state.fieldErrors}
								/>
							</div>
							<div className="my-3">
								<Label>{I18n.t('admin.user_profile.last_name')}</Label>
								<TextInput
									style={this.styleTextInputOnError('lastName')}
									placeholder=""
									name="lastName"
									value={this.state.lastName}
									onChange={this.onChange}
									fieldErrors={this.state.fieldErrors}
								/>
							</div>
							<div className="my-3">
								<Label>Date of Birth</Label>
								<DateOfBirthInput
									style={this.styleTextInputOnError('dateOfBirthMonth')}
									placeholder=""
									name="dateOfBirth"
									month={this.state.dateOfBirthMonth}
									day={this.state.dateOfBirthDay}
									year={this.state.dateOfBirthYear}
									onChange={this.onChange}
									fieldErrors={this.state.fieldErrors}
								/>
							</div>
							<div className="my-3">
								<Label>{I18n.t('admin.user_profile.email_address')}</Label>
								<TextInput
									style={this.styleTextInputOnError('emailAddress')}
									placeholder=""
									name="emailAddress"
									value={this.state.emailAddress}
									onChange={this.onChange}
									fieldErrors={this.state.fieldErrors}
								/>
							</div>
							<div className="my-3">
								<Label>{I18n.t('admin.user_profile.phone_number')}</Label>
								<TextInput
									style={this.styleTextInputOnError('phoneNumber')}
									placeholder=""
									name="phoneNumber"
									value={this.state.phoneNumber}
									onChange={this.onChange}
									fieldErrors={this.state.fieldErrors}
								/>
							</div>
							<div className="my-3">
								<Label>{I18n.t('admin.user_profile.address_line_1')}</Label>
								<TextInput
									style={this.styleTextInputOnError('addressLine1')}
									placeholder=""
									name="addressLine1"
									value={this.state.addressLine1}
									onChange={this.onChange}
									fieldErrors={this.state.fieldErrors}
								/>
							</div>
							<div className="my-3">
								<Label>{I18n.t('admin.user_profile.city')}</Label>
								<TextInput
									style={this.styleTextInputOnError('city')}
									placeholder=""
									name="city"
									value={this.state.city}
									onChange={this.onChange}
									fieldErrors={this.state.fieldErrors}
								/>
							</div>
							<div className="my-3">
								<Label>{I18n.t('admin.user_profile.state')}</Label>
								<TextInput
									style={this.styleTextInputOnError('stateAbr')}
									placeholder=""
									name="stateAbr"
									value={this.state.stateAbr}
									onChange={this.onChange}
									fieldErrors={this.state.fieldErrors}
								/>
							</div>
							<div className="my-3">
								<Label>{I18n.t('admin.user_profile.zip_code')}</Label>
								<TextInput
									style={this.styleTextInputOnError('zipCode')}
									placeholder=""
									name="zipCode"
									value={this.state.zipCode}
									onChange={this.onChange}
									fieldErrors={this.state.fieldErrors}
								/>
							</div>
						</FormSection>
						<FormSubmit
							text={I18n.t(
								'admin.user_profile.update_user_profile_submit_button'
							)}
						/>
					</form>
					{this.state.loading ? <LoaderOverlay /> : null}
				</div>
			</div>
		);
	}

	styleTextInputOnError(fieldName) {
		if (this.state.fieldErrors) {
			if (fieldName in this.state.fieldErrors) {
				return { border: '1px solid #ff3d60', borderRadius: '5px' };
			}
		}
	}

	onChange(e) {
		if (typeof e === 'object' && e !== null && e.month !== undefined) {
			// It's coming from DateOfBirthInput, handle properties accordingly
			this.setState({
				dateOfBirthMonth: e.month,
				dateOfBirthDay: e.day,
				dateOfBirthYear: e.year
			});
		} else {
			// It's a single input field
			this.setState({
				[e.target.name]: e.target.value
			});
		}
	}

	onSetFieldError(errorsArray, error) {
		if (errorsArray.includes(error)) {
			return 'Error';
		}
	}

	onSubmit(e) {
		// console.log(
		// 	'Editing User Profile - Personal Form...',
		// 	this.props.update_user_personal_endpoint
		// );
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			loading: true
		});

		$.ajax({
			type: 'POST',
			url: this.props.iam_update_user_profile_endpoint,
			data: {
				user_id: this.props.userId,
				presentationId: this.props.userData.personalData.presentationId,
				firstName: this.state.firstName,
				lastName: this.state.lastName,
				dateOfBirthMonth: this.state.dateOfBirthMonth,
				dateOfBirthDay: this.state.dateOfBirthDay,
				dateOfBirthYear: this.state.dateOfBirthYear,
				emailAddress: this.state.emailAddress,
				phoneNumber: this.state.phoneNumber,
				addressLine1: this.state.addressLine1,
				addressLine2: this.state.addressLine2,
				city: this.state.city,
				state: this.state.stateAbr,
				zipCode: this.state.zipCode
			},
			dataType: 'json'
		}).done((data) => {
			// console.log('Done!', data.status);
			if (data.status === 'success') {
				// console.log('User Profile - Personal Data updated!', data);
				this.setState({
					loading: false
				});
				// window.location.reload();
				this.props.updatePersonalData(data.data);
				this.props.onHidePopup();
				this.props.onShowSuccessCardPopup();
			} else if (data.status == 'session_expired') {
				// console.log('Session expired!');
				this.props.onHidePopup();
				this.props.onShowTimeoutCardPopup(
					setTimeout(() => {
						window.location.href = `/admin/${this.props.public_id}/signin`;
					}, 5000)
				);
			} else {
				this.setState({
					loading: false,
					globalErrors: data.data.global,
					fieldErrors: data.data.fields
				});
				console.log('Global errors', this.state.globalErrors);
				console.log('Field errors', this.state.fieldErrors);
			}
		});
	}

	loadData() {
		this.setState({ loading: true });
		$.ajax({
			type: 'GET',
			url: this.props.iam_get_user_personal_endpoint,
			data: {
				user_id: this.props.userData.summaryData.id
			}
		}).done((payload) => {
			const result = payload;
			// console.log('User personal data loaded!', result);
			this.setState({
				loading: false,
				firstName:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[0].value &&
					result.data.fields[0].value.asString,
				lastName:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[1].value &&
					result.data.fields[1].value.asString,
				dateOfBirthMonth:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[2].value &&
					result.data.fields[2].value.asString &&
					result.data.fields[2].value.asObject.dateOfBirth.month,
				dateOfBirthDay:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[2].value &&
					result.data.fields[2].value.asString &&
					result.data.fields[2].value.asObject.dateOfBirth.day,
				dateOfBirthYear:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[2].value &&
					result.data.fields[2].value.asString &&
					result.data.fields[2].value.asObject.dateOfBirth.year,
				emailAddress:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[3].value &&
					result.data.fields[3].value.asString,
				phoneNumber:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[4].value &&
					result.data.fields[4].value.asString,
				addressLine1:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[5].value &&
					result.data.fields[5].value.asString &&
					result.data.fields[5].value.asObject.postalAddress.domesticAddress
						.addressLine1,
				addressLine2:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[5].value &&
					result.data.fields[5].value.asString &&
					result.data.fields[5].value.asObject.postalAddress.domesticAddress
						.addressLine2,
				city:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[5].value &&
					result.data.fields[5].value.asString &&
					result.data.fields[5].value.asObject.postalAddress.domesticAddress
						.city,
				stateAbr:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[5].value &&
					result.data.fields[5].value.asString &&
					result.data.fields[5].value.asObject.postalAddress.domesticAddress
						.state,
				zipCode:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[5].value &&
					result.data.fields[5].value.asString &&
					result.data.fields[5].value.asObject.postalAddress.domesticAddress
						.zipCode
			});
		});
	}
}
